export default "__VITE_ASSET__6fc45c4c__"